import React from 'react';
import Meetings from '../Meetings';
import { useMeetingsStoreMyMeetings } from '../../store/meetingsStoreRepository';

const MyMeetings = () => {
  return (
    <Meetings
      title="My Meetings"
      routePrefix="/my-meetings"
      useStore={useMeetingsStoreMyMeetings}
      showBackButton={true}
    />
  );
};

export default MyMeetings;
